import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="#fff"
        d="M12.848 12.002a.89.89 0 0 0-.89.89v7.122c0 .492.399.89.89.89h7.122a.89.89 0 0 0 .89-.89v-7.122a.89.89 0 0 0-.89-.89z"
        opacity="0.4"
      ></path>
      <path
        fill="#fff"
        d="M10.33 8.585c1.609 0 2.914-1.129 2.914-2.867q0-.24-.032-.465l.439-.075a1.58 1.58 0 0 0 1.28-1.222l.106-.491-2.778.005a2.93 2.93 0 0 0-1.93-.702c-1.61 0-2.915 1.211-2.915 2.95 0 1.738 1.305 2.867 2.915 2.867M9.077 9.405a2.634 2.634 0 0 0-3.169 1.957l-1.96 8.293-.057.063h-1.96c-.245 0-.445.2-.445.445v.678c0 .246.2.445.445.445h19.374c.246 0 .445-.2.445-.445v-.678c0-.246-.2-.445-.445-.445H9.162l.87-3.035.005.02c.132.453.486.782.912.898q.111.052.236.082l6.027 1.45a2.003 2.003 0 0 0-1.264-2.454l-3.509-1.22-1.006-4.555a1.5 1.5 0 0 0-.26-.57 1.31 1.31 0 0 0-.844-.633z"
      ></path>
    </svg>
  )
}
